import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

function getMyGalleryOffers({ status, limit, offset } = {}) {
  const params = new URLSearchParams();

  if (status) {
    params.set('status', status);
  }
  if (limit !== undefined && limit !== null) {
    params.set('limit', String(limit));
  }
  if (offset !== undefined && offset !== null) {
    params.set('offset', String(offset));
  }

  const query = params.toString();
  const baseUrl = `${config.apis.api.url}/user/offers`;
  const url = query ? `${baseUrl}?${query}` : baseUrl;

  return fetchWrapper.get(url, {
    injectToken: true,
  });
}

const GalleryOffersService = {
  getMyGalleryOffers,
};

export default GalleryOffersService;
